var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPointerGlow = function SvgPointerGlow(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 90,
    viewBox: "-20 -15 56 90",
    fill: "none",
    style: {
      overflow: "visible"
    },
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "cleanGlow",
    x: "-200%",
    y: "-200%",
    width: "500%",
    height: "500%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur1",
    "in": "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur2",
    "in": "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur3",
    "in": "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "blur1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "blur2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "blur3"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#cleanGlow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 8,
    fill: "#FFFFFF",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 24 V43",
    stroke: "#FFFFFF",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 55.263C13 57.879 10.761 60 8 60C5.239 60 3 57.879 3 55.263C3 52.647 5.239 45 8 45C10.761 45 13 52.647 13 55.263Z",
    fill: "#FFFFFF",
    fillOpacity: 0.8
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPointerGlow);
export default ForwardRef;